import { createFetcher } from '../contexts/Fetcher';
import { useCallback } from 'react';
import { apiActivity } from '../resources/api/apiActivity';

const { useGetIpActivity } = apiActivity;

export const ActivityAccountFetcher = createFetcher(() => {
  const { execute: getAccountActivity } = useGetIpActivity();

  return useCallback(
    ({ ip }: { ip: string }) => {
      return getAccountActivity(ip);
    },
    [getAccountActivity]
  );
});
